import type {HighlightItem} from './types';

export const HIGHLIGHT_TIME_EPSILON = 1e-6;

export const getHighlightEndTime = (highlight: HighlightItem): number => {
  if (highlight.endTime != null) {
    return highlight.endTime;
  }

  return highlight.startTime + (highlight.duration ?? 0);
};

export const getHighlightActiveDuration = (
  highlight: HighlightItem,
): number => {
  return Math.max(0, getHighlightEndTime(highlight) - highlight.startTime);
};

export const isInstantPauseHighlight = (highlight: HighlightItem): boolean => {
  return (
    Math.abs(getHighlightEndTime(highlight) - highlight.startTime) <=
    HIGHLIGHT_TIME_EPSILON
  );
};

export const isHighlightActiveAtTime = (
  highlight: HighlightItem,
  currentTimeInSeconds: number,
): boolean => {
  if (isInstantPauseHighlight(highlight)) {
    return false;
  }

  const endTime = getHighlightEndTime(highlight);

  return (
    currentTimeInSeconds >= highlight.startTime &&
    currentTimeInSeconds < endTime
  );
};
